import SlotListDetails from "../../../../components/slot-list-details";

export default function AmbassadorSuggestedSlotsModal({ data, onClose }) {
  const times = data?.suggestedTimeSlots;
  const selectedSlot = data?.selectedTimeSlot;

  return (
    <SlotListDetails
      times={times}
      selectedSlot={selectedSlot}
      isCalendly={data?.isCalendly}
      onClose={onClose}
    />
  );
}
